// Single source of truth for brand identity.
// Rebranding this app = update this file, the locale files, the assets
// in client/public + attached_assets, and the CSS palette in index.css.
export const BRAND = {
  nameEn: "Time Clean",
  nameAr: "تايم كلين",
  /** International format, digits only — used for wa.me links */
  whatsappNumber: "96565566588",
  /** Local 8-digit format shown to customers */
  displayPhone: "65566588",
  instagramUrl: "https://www.instagram.com/kwttime",
  /** TODO: tentative — real domain not registered yet (see docs/TIMECLEAN-DEPLOYMENT.md) */
  siteUrl: "https://timecleankw.com",
} as const;

export const WHATSAPP_URL = `https://wa.me/${BRAND.whatsappNumber}`;
